<div class="foreman-tab-intro">
    <p class="text-muted mb-1">
        Vista marks employees as foremen by job title. Use the <strong>Is Foreman</strong> checkbox to add a user who is not a Vista
        foreman, or to exclude one who is. This determines who appears as a foreman across the Foreman Schedule.
    </p>
</div>

<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
            <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                style="margin-left: auto"
                (click)="refresh()"
                [disabled]="isLoading()"
            >
                {{ isLoading() ? 'Loading…' : 'Refresh' }}
            </button>
        </form>
    </div>
</div>

@if (loadError()) {
    <p class="text-danger">{{ loadError() }}</p>
}

<div class="row">
    <div class="col-12">
        <wj-flex-grid
            id="foremanRosterGrid"
            #foremanRosterGrid
            appAutoSize
            (initialized)="grid.initialize(foremanRosterGrid)"
            (destroy)="grid.destroy()"
            [itemsSource]="grid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Job Title'" [binding]="'jobTitle'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column
                [header]="'Vista Foreman'"
                [binding]="'isVistaForeman'"
                [width]="140"
                [align]="'center'"
                [isReadOnly]="true"
            ></wj-flex-grid-column>
            <wj-flex-grid-column
                [header]="'Is Foreman'"
                [binding]="'isForeman'"
                [width]="120"
                [align]="'center'"
                [isReadOnly]="!canEdit()"
            ></wj-flex-grid-column>
            <wj-flex-grid-column
                [header]="'Division'"
                [binding]="'divisionId'"
                [width]="220"
                [dataMap]="divisionMap"
                [isReadOnly]="!canEdit()"
            ></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
